import { render, staticRenderFns } from "./CursoListUpdateMedia.vue?vue&type=template&id=c1fecdb6&"
import script from "./CursoListUpdateMedia.vue?vue&type=script&lang=js&"
export * from "./CursoListUpdateMedia.vue?vue&type=script&lang=js&"
import style0 from "./CursoListUpdateMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports